import { render } from "./ParagraphPanel.vue?vue&type=template&id=e67697b8&scoped=true&ts=true"
import script from "./ParagraphPanel.vue?vue&type=script&lang=ts"
export * from "./ParagraphPanel.vue?vue&type=script&lang=ts"

import "./ParagraphPanel.vue?vue&type=style&index=0&id=e67697b8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e67697b8"]])

export default __exports__